<template>
  <div>
    <el-dialog
      title="新增证照信息"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <el-form size="small" class="form-centent">
        <div class="row">
          <div class="tip commo-text-ideograph">链接文字</div>
          <div class="value">
            <el-input v-model="formIn.linkText" maxlength="16" />
          </div>
        </div>
        <div class="row">
          <div class="tip commo-text-ideograph">链接地址</div>
          <div class="value">
            <el-input v-model="formIn.linkImage" maxlength="60" />
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitUpload()">确认</el-button>
      </span>
    </el-dialog>

    <UploadImageView
      ref="imgupload"
      request-id="1"
      :imgType="imgType"
      @upload="uploadSubmit"
    />
  </div>
</template>
<script>
import UploadImageView from "@/views/businessManage/checkShop/components/UploadImage.vue";
const IConst_See_Icon = require("@/assets/zz/see-icon.png");
const IConst_Del_Icon = require("@/assets/zz/del-icon.png");
const IConst_Add_Icon = require("@/assets/zz/add-icon.png");

export default {
  components: { UploadImageView },
  props: {
    requestId: {
      type: String,
      default: () => "",
    },

    limit: {
      type: Number,
      default: () => 10,
    },
  },
  computed: {
    headers: function () {
      return {
        Authorization: "Bearer " + getToken(),
      };
    },
  },
  data() {
    return {
      SeeIcon: IConst_See_Icon,
      DelIcon: IConst_Del_Icon,
      AddIcon: IConst_Add_Icon,

      imgType: "",
      IConst_Max_Pic_Count: 5,

      dialogVisible: false,
      formIn: {
        linkText: "",
        linkImage: "",
      },
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    init() {
      //
    },
    handleUpload() {
      this.$refs.imgupload.open(this.imgType);
    },
    uploadSubmit(obj) {
      const { type, url } = obj;
      this.formInfo.url = url;
    },
    handlePreview(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].showViewer = true;
      }
    },
    handleDeleteImage() {
      this.formInfo.url = "";
    },

    submitUpload() {
      if (!this.formIn.linkText) {
        this.$message.warning("请输入链接文字");
        return;
      }
      if (!this.formIn.linkText) {
        this.$message.warning("请输入链接地址");
        return;
      }
      this.$emit("addLink", this.formIn);
      this.dialogVisible = false;
    },
    clear() {
      for (let key in this.formIn) {
        this.formIn[key] = "";
      }
    },
    open() {
      this.clear();
      this.dialogVisible = true;
    },
  },
};
</script>
<style scoped lang="scss">
.form-centent {
  .row {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 8px;
    }

    .tip {
      width: 4em;
    }

    .value {
      width: 240px;
      margin-left: 8px;

      & > * {
        width: 100%;
      }
    }
  }
}
</style>
